export { default as BrandsPromo } from "./BrandsPromo";
